import type { SectionDetailLecturesItemContentType } from './sectionDetailLecturesItemContentType';
import type { SectionDetailLecturesItemPlatformSupport } from './sectionDetailLecturesItemPlatformSupport';

export type SectionDetailLecturesItem = {
  /** 강의 콘텐츠 유형 */
  contentType: SectionDetailLecturesItemContentType;
  /**
   * 강의 시간 (초)
   * @nullable
   */
  duration?: number | null;
  id: number;
  /** 현재 사용자의 강의 수강 완료 여부 */
  isCompleted: boolean;
  /** 섹션 내 강의 순서 */
  order: number;
  /** 강의 콘텐츠 지원 플랫폼 환경 */
  platformSupport: SectionDetailLecturesItemPlatformSupport;
  title: string;
};
